import { SHIPPING_SET } from "../contants/constants";

const initialState = {
  shipping: {},
};

export const shipping = (state = initialState, action) => {
  switch (action.type) {
    case SHIPPING_SET:
      return { ...state, shipping: action.payload };
    default:
      return state;
  }
};
